export const userLocale = () => {
  try {
    const c = document.cookie;
    const localeIndex = c.indexOf('userLocale');
    if (localeIndex === -1) throw Error('noUserLocaleDefined');
    const cookieLocale = c.substr(c.indexOf('=', localeIndex) + 1, 5);
    if (cookieLocale) {
      return cookieLocale;
    } else {
      if (navigator.language.indexOf('_')) {
        return navigator.language.replace('_', '-'); // changes language_RegionCode by language-RegionCode
      }
      return navigator.language; // language-RegionCode
    }
  } catch (e) {
    return navigator.language;
  }
};
